module.exports = __webpack_public_path__ + "static/media/portaprent-1.b9e6accb.png";


//////////////////
// WEBPACK FOOTER
// ./src/Img/logo/portaprent-1.png
// module id = 90
// module chunks = 0